import { AccountDataStreamType } from '@/types/generated/common/types'
import type { AccountDataStream } from '@/types/generated/public_api'

/** Build one batched RFQ subscription covering every currently-active account. */
export function buildRfqStreamPayload(accountIds: string[]): AccountDataStream {
  return {
    accountId: '',
    accountIds,
    dataType: AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_RFQS,
  }
}

/**
 * The maker-side RFQ_MAKER channel for the given accounts, batched like the taker channel
 * (the backend expands it per account and replays each account's open RFQs and quotes).
 * The backend silently drops it for an account whose plan lacks ALGO_TYPE_RFQ.
 */
export function buildRfqMakerStreamPayload(accountIds: string[]): AccountDataStream {
  return {
    accountId: '',
    accountIds,
    dataType: AccountDataStreamType.ACCOUNT_DATA_STREAM_TYPE_RFQ_MAKER,
  }
}

/**
 * accountIds takes precedence for batched subscriptions. The single accountId fallback
 * keeps the stream hook compatible with any legacy single-account caller.
 */
export function matchesRfqStreamAccount(
  messageAccountId: string | undefined,
  payload: AccountDataStream
): boolean {
  if (!messageAccountId) return false
  if (payload.accountIds.length > 0) return payload.accountIds.includes(messageAccountId)
  return messageAccountId === payload.accountId
}

/** Stable subscription identity; account membership changes must force a resubscribe. */
export function rfqStreamPayloadDeps(payload: AccountDataStream): unknown[] {
  return [[...payload.accountIds].sort().join(','), payload.accountId, payload.dataType]
}
